import { useMemo } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0DatePicker } from '@factorialco/f0-react'
import { DatePickerValue, Input, Switch } from '@factorialco/f0-react/dist/experimental'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import './index.styles.css'

type Props = {
  isEvent: boolean
  startsAt?: string
  location?: string
  startsAtError?: string

  onToggleIsEvent: (checked: boolean) => void
  onChangeStartsAt: (nextIso: string) => void
  onChangeLocation: (next: string) => void
}

const Event = ({
  isEvent,
  startsAt,
  location,
  startsAtError,
  onToggleIsEvent,
  onChangeStartsAt,
  onChangeLocation,
}: Props) => {
  const baseStartsAt = useMemo(() => startsAt ?? moment().toISOString(), [startsAt])

  const date = useMemo(
    () => ({
      granularity: 'day' as const,
      value: {
        from: moment(baseStartsAt).toDate(),
        to: moment(baseStartsAt).toDate(),
      },
    }),
    [baseStartsAt]
  )
  const time = useMemo(() => moment(baseStartsAt).format('HH:mm'), [baseStartsAt])

  const setEventDay = (
    datePickerValue: DatePickerValue | undefined,
    _stringValue?: string | undefined
  ) => {
    const format = moment.localeData().longDateFormat('L')
    const newDate = moment(datePickerValue?.value?.from, format)
    const existing = moment(baseStartsAt)

    existing.set('date', newDate.date()).set('month', newDate.month()).set('year', newDate.year())
    onChangeStartsAt(existing.toISOString())
  }

  const setEventTime = (t: string) => {
    const newTime = moment(t, 'HH:mm')
    const existing = moment(baseStartsAt)

    existing.set('hour', newTime.hour()).set('minutes', newTime.minutes())
    onChangeStartsAt(existing.toISOString())
  }

  return (
    <>
      <Box gap="s12" paddingX="s16" paddingY="s16" className={'Event_isEventContainer'}>
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Box gap="s4">
            <Text.Normal size="200" weight="medium" color="black">
              {i18n.t('posts.communities.quick_post.is_event_label')}
            </Text.Normal>
            <Text.Normal size="100">
              {i18n.t('posts.communities.quick_post.is_event_description')}
            </Text.Normal>
          </Box>

          <Switch
            checked={isEvent}
            onCheckedChange={onToggleIsEvent}
            title={i18n.t('posts.communities.quick_post.is_event_label')}
            hideLabel
          />
        </Box>
      </Box>

      {isEvent && (
        <>
          <Box flexDirection="row" gap="s16" className={'QuickPostEditor_isEventContainer'}>
            <Box gap="s6" style={{ width: '25%' }}>
              <F0DatePicker
                label={i18n.t('posts.communities.event_start_date')}
                onChange={setEventDay}
                size="sm"
                value={date}
                minDate={new Date()}
              />
            </Box>

            <Box gap="s6" style={{ width: '25%' }}>
              <Input
                label={i18n.t('posts.communities.event_start_time')}
                type="time"
                value={time}
                onChange={setEventTime}
              />
            </Box>

            <Box gap="s6" style={{ width: '50%' }}>
              <Input
                value={location ?? ''}
                label={i18n.t('posts.communities.event_location')}
                placeholder={i18n.t('posts.communities.event_location_placeholder')}
                onChange={onChangeLocation}
              />
            </Box>
          </Box>

          {startsAtError && (
            <Text size="200" color="radicalRed1000" capitalize>
              {startsAtError}
            </Text>
          )}
        </>
      )}
    </>
  )
}

export default Event
